<template>
  <label class="switch" :class="[size, disabled ? 'disabled' : '']">
    <input type="checkbox" :name="name" v-model="inputModel"
           :disabled="disabled"
          />
    <span class="slider round" :class="mode"></span>
  </label>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'SwitchElement',
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: ''
    }
    // isChecked:{
    //   type: Boolean,
    //   default:false
    // },
  },
  computed: {
    inputModel: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean): void {
        this.$emit('update:value', value);
      },
    },

  },
});
</script>

<style lang="scss" scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 28px;

  &.small {
    width: 35px;
    height: 20px;

    .slider {
      &::before {
        height: 16px;
        width: 16px;
        left: 3px;
      }
    }

    input {
      &:checked + .slider:before {
        transform: translateX(13px);
      }
    }
  }

  &.disabled {
    .slider{
      opacity: 0.3;
    }
  }

  input {
    opacity: 0;
    width: 0;
    height: 0;

    &:checked + .slider {
      background-color: var(--green-100);
    }

    &:checked + .slider.upgrade {
      background-color: var(--accent-100);
    }

    &:checked + .slider:before {
      transform: translateX(22px);
    }
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--neutral-200);
    transition: 0.4s;

    &.upgrade {
      background-color: var(--text-dark);
    }

    &::before {
      position: absolute;
      content: "";
      height: 24px;
      width: 24px;
      bottom: 2px;
      left: 3px;
      background-color: var(--light-100);
      transition: 0.4s;
    }
  }

  .slider.round {
    border-radius: $br-lg-oval;

    &::before {
      border-radius: $br-circle;
    }
  }
}
</style>
